/** Fixed at build time (`scripts/build.ts`): the Supabase project accounts signs in to, the clients it approves without asking, and the web app it links back to. */
declare const __ACCOUNTS_CONFIG__: {
  readonly supabaseUrl: string;
  readonly supabasePublishableKey: string;
  readonly firstPartyClientIds: readonly string[];
  readonly webUrl: string;
};

export const CONFIG: {
  readonly supabaseUrl: string;
  readonly supabasePublishableKey: string;
  readonly firstPartyClientIds: readonly string[];
  readonly webUrl: string;
} = __ACCOUNTS_CONFIG__;
